module.exports = __webpack_public_path__ + "img/9788949120652.6613c44d.jpg";